/*
    Right now the logic is very simple. 
    But a separate util was created in anticipation of requirements evolving.
*/
const getSource = (utmSource, entityID, faNo, contactId) => {
  if (!contactId) {
    if (entityID) {
      return 'fa_profile';
    }
    if (faNo) {
      return 'personalized_link';
    }
  } else if (!utmSource) {
    if (entityID || faNo) {
      return 'email';
    }
  }
  return utmSource;
};

export default getSource;
